export default function bankAccountFormat(bunkAccount: string) {
  const endOfNumber = bunkAccount.slice(20, 24);
  const startOfNumber = bunkAccount.slice(0, 4);
  const printedBankNumber = `${startOfNumber}-****-****-**-******${endOfNumber}`;

  return printedBankNumber;
}
